export const labelByResolutionState = {
  resolved: "Resolved",
  upcoming: "Resolves",
};
